$shm_hitalama_profile_switch $mol_view
	profile null $shm_hitalama_profile
	align \bottom_left
	sub /
		<= Client_copy $shm_button_copy
			title \ID
			hint \Скопировать ID клиента
			text <= client_id \
		<= Login $mol_link
			title <= login \
			sub / <= Login_badge $shm_hitalama_profile_badge
				name <= login \
				avatar_uri <= avatar_uri \
			hint \Личный кабинет
			arg * section \profile
	buttons /
		<= Enter_link $mol_link
			title \Войти
			uri \/login
		<= Register_link $mol_link
			title \Регистрация
			uri \/login
